import React from "react";
import Images from "../../../assets/images/index";
import { useNavigate } from "react-router-dom";

export default function Success (){ 
    let navigate = useNavigate()
    const goHome = ()=>{
        // console.log("hhhhhhhhhhhhhhh")
        navigate('/videolayer');
    }
    return(
        <div className="success_wrapper text-center">
            <figure>
                <img src={Images.Success} alt="" className="img-fluid"/>
            </figure>
            <div className="success_content">
                <h6>Transaction Successful</h6>
                <p>Your Transaction is successful. Your Content is unlocked now. Happy Learning.</p>
                <div className="sucess_btn">
                    <button type="button" className="btn btn_success" onClick={()=>goHome()}>Start Learning</button>
                </div>
            </div>
        </div>
    )
}